@if (user$ | async; as user) {
  <mat-toolbar
    *flexyooLet="isSmallView$ | async as isSmallView"
    class="flexyoo-header-toolbar"
  >
    <div #logoEl ngStyle.gt-md="margin-right: 100px;" style="display: inline-flex; cursor: pointer">
      @if (!wlc.logoFilePath) {
        <img
          alt="Logo"
          src="assets/images/logo.png"
          style="object-fit: contain; max-width: 150px"
        />
      }
      @if (wlc.logoFilePath) {
        <img
          alt="Tenant Logo"
          style="object-fit: contain; max-width: 150px"
          [src]="wlc.logoFilePath + '?hash=' + wlc.logoHash"
        />
      }
    </div>
    @if (isSmallView || !user.Impersonated) {
      <span class="header-spacer"></span>
    } @else if (user.Impersonated) {
      <div class="header-impersonated-banner">
        <ng-container
          [ngTemplateOutlet]="impersonatedBannerTemplate"
          [ngTemplateOutletContext]="{ user: user, isBannerView: false }"
        ></ng-container>
      </div>
    }
    @if (user) {
      @if (user.Role === 'HR' || user.Role === 'Employee') {
        <app-hr-notifications-dropdown></app-hr-notifications-dropdown>
      }
      @if (user.Role !== 'Admin') {
        @if (user.TenantName && user.Role === 'HR') {
          @if (tenantItems$ | async; as tenantItems) {
            <app-tenant-global-filter
              [defaultValue]="tenantItems"
              [items]="tenantItems"
              [ngModel]="tenantGlobalFilter$ | async"
            ></app-tenant-global-filter>
          }
        } @else {
          @let opcoName = user.Role === 'Opco' ? user.OpcoName : user.TenantName;
          <span
            class="header-tenant-name-tooltip"
            matTooltipClass="header-tenant-name__tooltip"
            [matTooltip]="opcoName"
            [matTooltipDisabled]="!opcoName"
          >
            <button
              class="header-tenant-name"
              matButton="filled"
              [class.header-tenant-name_empty]="!opcoName"
              [disabled]="true"
            >
              <mat-icon style="flex: 0 0 24px; font-size: 24px">domain</mat-icon>{{ opcoName }}
            </button>
          </span>
        }
      }
      <button
        class="header-tenant-name"
        matButton="filled"
        matTooltipClass="header-tenant-name__tooltip"
        [matMenuTriggerFor]="menu"
        [matTooltip]="user.UserName && !isSmallView ? user.UserName : null"
      >
        <mat-icon aria-label="username" style="flex: 0 0 24px; font-size: 24px"
          >perm_identity</mat-icon
        >{{ user.UserName }}
      </button>
      <mat-menu #menu="matMenu" class="user-menu-panel">
        <app-user-menu [user]="user"></app-user-menu>
      </mat-menu>
    }
  </mat-toolbar>

  @if (isYearClosingBannerVisible$ | async) {
    <ng-container *flexyooLet="hrYearClosingBannerInfo$ | async as hrYearClosingBannerInfo">
      <div
        class="hr-year-closing-mode-banner"
        [style.background-color]="wlc.warnColor"
        [style.color]="wlc.warnContrastingColor"
      >
        @if (hrYearClosingBannerInfo?.isEnabledForCurrentTenantMulti) {
          {{
            'hr.year-closing-banner-multi'
              | translate: { title: ('hr.year-closing-banner-multi-current' | translate) }
          }}
        } @else if (hrYearClosingBannerInfo?.isEnabledForCurrentTenant) {
          {{ 'hr.year-closing-banner' | translate }}
        } @else {
          <span
            [matTooltip]="
              hrYearClosingBannerInfo?.enabledForOtherTenants
                ? (multiTenantsYearClosingTooltip$ | async)
                : null
            "
            >{{
              'hr.year-closing-banner-multi'
                | translate
                  : {
                      title: hrYearClosingBannerInfo?.enabledForAnotherTenant
                        ? hrYearClosingBannerInfo?.enabledForAnotherTenant
                        : hrYearClosingBannerInfo?.enabledForOtherTenants,
                    }
            }}</span
          >
        }
        <a
          [routerLink]="'/hr/payroll-management/year-closing'"
          [style.color]="wlc.warnContrastingColor"
        >
          <mat-icon>navigate_next</mat-icon></a
        >
      </div>
    </ng-container>
  }

  <mat-sidenav-container
    *flexyooLet="isTwoPlans$ | async as isTwoPlans"
    autosize
    class="app-sidenav-container"
    [class.app-sidenav-container_with-year-closing-banner]="isYearClosingBannerVisible$ | async"
    [class.notifications-sidebar-visible]="isNotificationSidebarVisible$ | async"
  >
    <mat-sidenav
      *flexyooLet="isExpanded$ | async as isExpanded"
      #sidenav
      disableClose="true"
      mode="side"
      opened="true"
      [style.width]="'auto'"
      (keydown.escape)="setIsExpanded(false)"
    >
      <div *flexyooLet="links$ | async as links" class="layout-side-navigation">
        <mat-nav-list [class.layout-side-navigation__list]="!isExpanded">
          <mat-list-item (click)="setIsExpanded(!isExpanded)">
            <mat-icon matTooltip="{{ isExpanded ? '' : ('base-layout.main-menu' | translate) }}"
              >menu</mat-icon
            >
            @if (isExpanded) {
              <span>Menu</span>
            }
            @if (isExpanded) {
              <mat-icon style="position: absolute; right: 0">navigate_before</mat-icon>
            }
            <mat-divider></mat-divider>
          </mat-list-item>
          @for (flexyooLink of links; track $index) {
            @if (user.Role === flexyooLink.role) {
              @if (flexyooLink.isExpandable) {
                <mat-list-item (click)="flexyooLink.isOpened = !flexyooLink.isOpened">
                  @if (flexyooLink.isCustomIcon) {
                    <mat-icon
                      [matTooltip]="isExpanded ? '' : (flexyooLink.translationsKey | translate)"
                      [svgIcon]="flexyooLink.icon"
                    ></mat-icon>
                  } @else {
                    <mat-icon
                      [matTooltip]="isExpanded ? '' : (flexyooLink.translationsKey | translate)"
                      >{{ flexyooLink.icon }}</mat-icon
                    >
                  }

                  @if (isExpanded) {
                    <span> {{ flexyooLink.translationsKey | translate }}</span>
                  }
                  <mat-icon class="menu-button" [ngClass]="{ rotated: flexyooLink.isOpened }"
                    >expand_more</mat-icon
                  >
                </mat-list-item>

                @if (flexyooLink.isOpened) {
                  <div class="submenu" [ngClass]="{ expanded: flexyooLink.isOpened }">
                    @for (childLink of flexyooLink.children; track $index) {
                      <mat-list-item
                        #routerLinkActiveInstance="routerLinkActive"
                        routerLinkActive
                        [activated]="routerLinkActiveInstance.isActive"
                        [disabled]="childLink.isDisabled"
                        [routerLink]="childLink.isDisabled ? null : childLink.link"
                        [style.color]="routerLinkActiveInstance.isActive ? wlc.primaryColor : ''"
                        (click)="setIsExpanded(false, childLink.isDisabled, $event)"
                      >
                        @if (childLink.isCustomIcon) {
                          <mat-icon
                            [class]="childLink.iconClass ?? ''"
                            [matTooltip]="isExpanded ? '' : (childLink.translationsKey | translate)"
                            [style.color]="
                              routerLinkActiveInstance.isActive ? wlc.primaryColor : ''
                            "
                            [svgIcon]="childLink.icon"
                          ></mat-icon>
                        } @else {
                          <mat-icon
                            [matTooltip]="isExpanded ? '' : (childLink.translationsKey | translate)"
                            [style.color]="
                              routerLinkActiveInstance.isActive ? wlc.primaryColor : ''
                            "
                            >{{ childLink.icon }}</mat-icon
                          >
                        }
                        @if (isExpanded) {
                          <span
                            [style.color]="
                              routerLinkActiveInstance.isActive ? wlc.primaryColor : ''
                            "
                          >
                            {{ childLink.translationsKey | translate }}</span
                          >
                        }
                      </mat-list-item>
                    }
                  </div>
                }
              } @else {
                <mat-list-item
                  #routerLinkActiveInstance="routerLinkActive"
                  routerLinkActive
                  [activated]="routerLinkActiveInstance.isActive"
                  [disabled]="flexyooLink.isDisabled"
                  [routerLink]="flexyooLink.isDisabled ? null : flexyooLink.link"
                  (click)="setIsExpanded(false, flexyooLink.isDisabled, $event)"
                >
                  @if (flexyooLink.isCustomIcon) {
                    <mat-icon
                      [class]="flexyooLink.iconClass ?? ''"
                      [matTooltip]="isExpanded ? '' : (flexyooLink.translationsKey | translate)"
                      [style.color]="routerLinkActiveInstance.isActive ? wlc.primaryColor : ''"
                      [svgIcon]="flexyooLink.icon"
                    ></mat-icon>
                  } @else {
                    <mat-icon
                      [matTooltip]="isExpanded ? '' : (flexyooLink.translationsKey | translate)"
                      [style.color]="routerLinkActiveInstance.isActive ? wlc.primaryColor : ''"
                      >{{ flexyooLink.icon }}</mat-icon
                    >
                  }
                  @if (isExpanded) {
                    <span [style.color]="routerLinkActiveInstance.isActive ? wlc.primaryColor : ''">
                      {{ flexyooLink.translationsKey | translate }}</span
                    >
                  }
                </mat-list-item>
              }
            }
          }
        </mat-nav-list>
        <app-sidenav-logo
          class="sidenav-logo"
          [class.sidenav-logo_collapsed]="!isExpanded"
        ></app-sidenav-logo>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="height100">
      @if (user.Impersonated && isSmallView$ | async) {
        <ng-container
          [ngTemplateOutlet]="impersonatedBannerTemplate"
          [ngTemplateOutletContext]="{ user: user, isBannerView: true }"
        ></ng-container>
      }
      <div style="height: auto; padding-top: 20px">
        @if (loading) {
          <flexyoo-loader></flexyoo-loader>
        }
        <!--
          The outlet is only hidden, never removed: destroying it on NavigationStart would
          tear the routed component down before its canDeactivate guard has even been asked,
          and a navigation the guard then cancels would leave the outlet empty for good.
        -->
        <div [hidden]="loading">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
    @if (user.Role === 'HR' || user.Role === 'Employee') {
      <mat-sidenav
        mode="over"
        position="end"
        [autoFocus]="false"
        [opened]="isNotificationSidebarVisible$ | async"
        (closed)="closeNotificationsSidebar()"
      >
        <app-notifications-sidebar [isHrUser]="user.Role === 'HR'"></app-notifications-sidebar>
      </mat-sidenav>
    }
  </mat-sidenav-container>
}

<ng-template #impersonatedBannerTemplate let-isBannerView="isBannerView" let-user="user">
  <app-impersonated-banner
    [impersonation]="user.Impersonated"
    [isBannerView]="isBannerView"
    [tenantName]="user.TenantName"
    [userName]="user.UserName"
    (close)="onLogout()"
  >
  </app-impersonated-banner>
</ng-template>
